import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {
  iaIconChevronRight,
  iaIconCircleCheckFilled,
  iaIconCircleInformation,
  iaIconInformationWhite,
  iaIconMessagesDots,
  iaIconXmarkAlt,
} from '@bcef/ia-icons';
import { iaIconBulbNhb } from '@bcef/ia-icons/nhb';
import { IconsRegistry } from '@bcef/ia-ng-icons';
import { ContextService, getClassNames } from '@bcef/ia-shared';
import { DataLayer } from '@difa/ia-data-layer';
import { TranslateService } from '@ngx-translate/core';
import classNames from 'classnames';

import { ConnectionContextService } from '@features/termination/services';

@Component({
  selector: 'ia-resil-contrats-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom,
  imports: [RouterOutlet],
  standalone: true,
})
export class AppComponent implements OnInit {
  protected typologies = '';

  private readonly contextService = inject(ContextService);

  private readonly translate = inject(TranslateService);

  private readonly iconsRegistry = inject(IconsRegistry);

  private readonly connectionContextService = inject(ConnectionContextService);

  private readonly _datalayer = inject(DataLayer);

  public ngOnInit(): void {
    this.translate.use(this.contextService.language);
    this.typologies = classNames([
      getClassNames(this.contextService.typology),
      this.connectionContextService.isConnected ? 'tw-connected' : 'tw-not-connected',
    ]);
    this.iconsRegistry.registerIcons([
      iaIconXmarkAlt,
      iaIconChevronRight,
      iaIconInformationWhite,
      iaIconCircleCheckFilled,
      iaIconCircleInformation,
      iaIconMessagesDots,
      iaIconBulbNhb,
    ]);
  }
}
